import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export const YesButton = withStyles(() => ({
  root: {
    margin: '10px',
    width: '120px',
    padding: '0px',
    height: '40px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      border: 'solid 1px #3C419A',
      color: '#FFFFFF',
      backgroundColor: '#3C419A',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(Button);

export const NoButton = withStyles(() => ({
  root: {
    margin: '10px',
    width: '120px',
    padding: '0px',
    height: '40px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      border: 'solid 1px #3C419A',
      color: '#FFFFFF',
      backgroundColor: '#3C419A',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(Button);
